module.exports = __webpack_public_path__ + "static/note-importance-dont-7cd976e225b9a993f9e8cebb49541ddd.png";